module.exports = "https://assets.calmac.co.uk/scripts/apps/overlays/1.7/img/Recent.svg";